import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import SpinLoading from '@/components/spin-loading';

const Root = () => {
  return (
    <Suspense fallback={ <SpinLoading src={ require('@/images/loading-orange.png') } /> }>
      <Outlet />
    </Suspense>
  );
};

export default Root;
